var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "white"
    },
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m457 80h-15v-35c0-24.813-20.187-45-45-45s-45 20.187-45 45v12.285c0 15.544-10.438 29.383-25.385 33.653l-14.615 4.176v-.114c0-8.284-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15v67h-177c-24.813 0-45 20.187-45 45v290c0 5.532 3.045 10.615 7.922 13.225 2.218 1.188 4.65 1.775 7.077 1.775 2.91 0 5.812-.846 8.321-2.52l56.222-37.48h285.458c24.813 0 45-20.187 45-45v-157h47c30.327 0 55-24.673 55-55v-80c0-30.327-24.673-55-55-55zm-205 30h30v130h-30zm128 317c0 8.271-6.729 15-15 15h-290c-2.961 0-5.856.877-8.32 2.52l-36.68 24.453v-261.973c0-8.271 6.729-15 15-15h177v63c0 8.284 6.716 15 15 15h60c7.706 0 14.048-5.814 14.896-13.293 13.363 8.522 29.075 13.293 45.415 13.293h22.689zm102-212c0 13.785-11.215 25-25 25h-99.689c-18.238 0-35.271-9.201-45.311-24.246v-89.439l22.856-6.53c27.758-7.931 47.144-33.632 47.144-62.5v-12.285c0-8.271 6.729-15 15-15s15 6.729 15 15v50c0 8.284 6.716 15 15 15h30c13.785 0 25 11.215 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 282h100c8.284 0 15-6.716 15-15s-6.716-15-15-15h-100c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 312h-260c-8.284 0-15 6.716-15 15s6.716 15 15 15h260c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 372h-260c-8.284 0-15 6.716-15 15s6.716 15 15 15h260c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.0452f5f2.svg";
export { ForwardRef as ReactComponent };